// extracted by mini-css-extract-plugin
export var container = "_4x-0";
export var icon = "_4x-1";
export var text = "_4x-2";